export default "__VITE_ASSET__B29gu6a8__"